<template>
    <div>
        <form autocomplete="off" @submit.prevent="postPerfil()">
            <vs-row class="p-4">
                <vs-col w="12" class="lineTitulo mb-2">
                    <h5><strong>PERFIL</strong></h5>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Apellido paterno *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.apellido_paterno"
                        placeholder="Apellido paterno"
                        :disabled="deshabilitadas || personaRol.roles[0].id == 2"
                    >
                        <template #message-danger v-if="errorFields.includes('apellido_paterno')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Apellido materno *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.apellido_materno"
                        placeholder="Apellido materno"
                        :disabled="deshabilitadas || personaRol.roles[0].id == 2"
                    >
                        <template #message-danger v-if="errorFields.includes('apellido_materno')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Nombre(s) *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.nombres"
                        placeholder="Nombre(s)"
                        :disabled="deshabilitadas || personaRol.roles[0].id == 2"
                    >
                        <template #message-danger v-if="errorFields.includes('nombres')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Sexo *</label>
                    <vs-select
                        v-if="info.apellido_paterno"
                        filter
                        class="pt-0"
                        placeholder="Sexo" 
                        v-model="info.sexo"
                        :key="sexoId"
                        :disabled="deshabilitadas"
                    >
                        <vs-option label="Masculino" value="masculino">
                            Masculino
                        </vs-option>
                        <vs-option label="Femenino" value="femenino">
                            Femenino
                        </vs-option>
                        <vs-option label="Sin indicar" value="pordefinir">
                            Sin indicar
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('sexo')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Fecha de nacimiento *</label>
                    <vs-input
                        type="date"
                        class="pt-0"
                        v-model="info.fecha_nacimiento"
                        :disabled="deshabilitadas"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_nacimiento')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>CURP *</label>
                    <vs-input
                        class="pt-0"
                        :class="invalidoCurp ? 'pb-0' : ''"
                        v-model="info.curp"
                        placeholder="CURP"
                        :disabled="deshabilitadas || personaRol.roles[0].id == 2"
                    >
                        <template #message-danger v-if="errorFields.includes('curp')">
                           <span>{{errorCURP ? errorCURP : 'Requerido'}}</span> 
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Correo electrónico *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.correo"
                        placeholder="Correo electrónico"
                        :disabled="deshabilitadas || personaRol.roles[0].id == 2"
                    >
                        <template #message-danger v-if="errorFields.includes('correo')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Celular</label>
                    <vs-input
                        min="0"
                        @input="numeroMaximo(info.celular, 'celular')"
                        type="tel"
                        class="pt-0"
                        v-model="info.celular"
                        placeholder="Celular"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Teléfono</label>
                    <vs-input
                        min="0"
                        @input="numeroMaximo(info.telefono, 'telefono')"
                        type="tel"
                        class="pt-0"
                        v-model="info.telefono"
                        placeholder="Teléfono"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Extensión</label>
                    <vs-input
                        min="0"
                        type="number"
                        class="pt-0"
                        v-model="info.extension"
                        placeholder="Extensión"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Estado *</label>
                    <vs-select 
                        filter 
                        class="pt-0"
                        placeholder="Estado"
                        :key="estadoId" 
                        v-model="info.estado_id"
                        :disabled="deshabilitadas"
                    >
                        <template #message-danger v-if="errorFields.includes('estado')">
                            Requerido
                        </template>
                        <vs-option
                            v-for="option in estados" 
                            :key="option.id"
                            :label="option.text"
                            :value="option.id"
                            :disabled="deshabilitadas"
                        >
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Ciudad</label>
                    <vs-select
                        filter
                        :loading="loadingCiudad"
                        class="pt-0"
                        placeholder="Ciudad"
                        :key="ciudadId" 
                        v-model="info.ciudad_id" 
                        :disabled="!ciudades.length || deshabilitadas"
                    >
                        <template #message-danger v-if="errorFields.includes('ciudad')">
                            Requerido
                        </template>
                        <vs-option
                            v-for="option in ciudades" 
                            :key="option.id"
                            :label="option.text"
                            :value="option.id"
                        >
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Delegación</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.delegacion"
                        placeholder="Delegación"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Código Postal</label>
                    <vs-input
                        min="0"
                        type="number"
                        class="pt-0"
                        v-model="info.cp"
                        placeholder="Código Postal"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Colonia</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.colonia"
                        placeholder="Colonia"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Calle</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.calle"
                        placeholder="Calle"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Número</label>
                    <vs-input
                        min="0"
                        type="number"
                        class="pt-0"
                        v-model="info.numero"
                        placeholder="Número"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Lugar de nacimiento</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.lugar_nacimiento"
                        placeholder="Lugar de nacimiento"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Nacionalidad *</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Nacionalidad"
                        :key="nacionalidadId" 
                        v-model="info.nacionalidad" 
                        :disabled="!nacionalidades.length || deshabilitadas"
                    >
                        <template #message-danger v-if="errorFields.includes('nacionalidad')">
                            Requerido
                        </template>
                        <vs-option
                            v-for="option in nacionalidades" 
                            :key="option.id"
                            :label="option.text"
                            :value="option.id"
                        >
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Número de dependientes</label>
                    <vs-input
                        min="0"
                        type="number"
                        class="pt-0"
                        v-model="info.no_dependientes"
                        placeholder="Número de dependientes"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col v-if="general && general.datos && general.datos.tipo != 'prospecto'" class="inputTitulo" sm="12" lg="4">
                    <label>Vive con</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.vive_con"
                        placeholder="Vive con"
                        :disabled="deshabilitadas"
                    />
                </vs-col>
                <vs-col w="12" class="mt-2">
                    <vs-button
                        v-if="!deshabilitadas"
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </vs-col>
            </vs-row>
        </form>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'personaRol'
    ],
    data(){
        return{
            sexo: '',
            info: {},
            estados: [
                {id: 1, text: 'Aguascalientes'},
                {id: 2, text: 'Baja California'},
                {id: 3, text: 'Baja California Sur'},
                {id: 4, text: 'Campeche'},
                {id: 5, text: 'Coahuila de Zaragoza'},
                {id: 6, text: 'Colima'},
                {id: 7, text: 'Chiapas'},
                {id: 8, text: 'Chihuahua'},
                {id: 9, text: 'Ciudad de México'},
                {id: 10,text: 'Durango'},
                {id: 11,text: 'Guanajuato'},
                {id: 12,text: 'Guerrero'},
                {id: 13,text: 'Hidalgo'},
                {id: 14,text: 'Jalisco'},
                {id: 15,text: 'Estado de México'},
                {id: 16,text: 'Michoacán de Ocampo'},
                {id: 17,text: 'Morelos'},
                {id: 18,text: 'Nayarit'},
                {id: 19,text: 'Nuevo León'},
                {id: 20,text: 'Oaxaca'},
                {id: 21,text: 'Puebla'},
                {id: 22,text: 'Querétaro'},
                {id: 23,text: 'Quintana Roo'},
                {id: 24,text: 'San Luis Potosí'},
                {id: 25,text: 'Sinaloa'},
                {id: 26,text: 'Sonora'},
                {id: 27,text: 'Tabasco'},
                {id: 28,text: 'Tamaulipas'},
                {id: 29,text: 'Tlaxcala'},
                {id: 30,text: 'Veracruz'},
                {id: 31,text: 'Yucatán'},
                {id: 32,text: 'Zacatecas',}
            ],
            estadoId: (new Date()).getTime(),
            ciudades: [],
            ciudadId: (new Date()).getTime(),
            sexoId: (new Date()).getTime(),
            loadingCiudad: false,
            nacionalidades:[
                {id: 'Alemán',text: 'Alemán'},
                {id: 'Argentino',text: 'Argentino'},
                {id: 'Australiano',text: 'Australiano'},
                {id: 'Austriaco',text: 'Austriaco'},
                {id: 'Belga',text: 'Belga'},
                {id: 'Beliceño',text: 'Beliceño'},
                {id: 'Boliviano',text: 'Boliviano'},
                {id: 'Brasileño',text: 'Brasileño'},
                {id: 'Canadiense',text: 'Canadiense'},
                {id: 'Chileno',text: 'Chileno'},
                {id: 'Chino',text: 'Chino'},
                {id: 'Colombiano',text: 'Colombiano'},
                {id: 'Nortecoreano - Norcoreano',text: 'Nortecoreano - Norcoreano'},
                {id: 'Sudcoreano',text: 'Sudcoreano'},
                {id: 'Costarricense - Costarriqueño',text: 'Costarricense - Costarriqueño'},
                {id: 'Cubano',text: 'Cubano'},
                {id: 'Croata',text: 'Croata'},
                {id: 'Dané',text: 'Dané'},
                {id: 'Ecuatoriano',text: 'Ecuatoriano'},
                {id: 'Egipcio',text: 'Egipcio'},
                {id: 'Salvadoreño',text: 'Salvadoreño'},
                {id: 'Escocés',text: 'Escocés'},
                {id: 'Española',text: 'Española'},
                {id: 'Estadounidense - Norteamericano - Americano',text: 'Estadounidense - Norteamericano - Americano'},
                {id: 'Filipino',text: 'Filipino'},
                {id: 'Francés',text: 'Francés'},
                {id: 'Galés',text: 'Galés'},
                {id: 'Británico',text: 'Británico'},
                {id: 'Griego',text: 'Griego'},
                {id: 'Guatemalteca',text: 'Guatemalteca'},
                {id: 'Haitiano',text: 'Haitiano'},
                {id: 'Hondureño',text: 'Hondureño'},
                {id: 'Húngaro',text: 'Húngaro'},
                {id: 'Indio - Hindú',text: 'Indio - Hindú'},
                {id: 'Inglés',text: 'Inglés'},
                {id: 'Irakí - Iraquí',text: 'Irakí - Iraquí'},
                {id: 'Iraní',text: 'Iraní'},
                {id: 'Irlandés',text: 'Irlandés'},
                {id: 'Israelí',text: 'Israelí'},
                {id: 'Italiano',text: 'Italiano'},
                {id: 'Japonesa',text: 'Japonesa'},
                {id: 'Marroquí',text: 'Marroquí'},
                {id: 'Mexicana',text: 'Mexicana'},
                {id: 'Myanma - Birmano',text: 'Myanma - Birmano'},
                {id: 'Nicaragüense',text: 'Nicaragüense'},
                {id: 'Noruego',text: 'Noruego'},
                {id: 'Neozelandés',text: 'Neozelandés'},
                {id: 'Holandés',text: 'Holandés'},
                {id: 'Palestino',text: 'Palestino'},
                {id: 'Panameño',text: 'Panameño'},
                {id: 'Paraguayo',text: 'Paraguayo'},
                {id: 'Peruano',text: 'Peruano'},
                {id: 'Polaco',text: 'Polaco'},
                {id: 'Portugués',text: 'Portugués'},
                {id: 'Puertorriqueño',text: 'Puertorriqueño'},
                {id: 'Dominicano',text: 'Dominicano'},
                {id: 'Ruso',text: 'Ruso'},
                {id: 'Sudafricano',text: 'Sudafricano'},
                {id: 'Sueco',text: 'Sueco'},
                {id: 'Suizo',text: 'Suizo'},
                {id: 'Taiwanés',text: 'Taiwanés'},
                {id: 'Uruguayo',text: 'Uruguayo'},
                {id: 'Venezolano',text: 'Venezolano'},
                {id: 'Mexicana y Estadounidense',text: 'Mexicana y Estadounidense'},
                {id: 'Mexicana y Guatemalteca',text: 'Mexicana y Guatemalteca'},
                {id: 'Mexicana y Japonesa',text: 'Mexicana y Japonesa'},
                {id: 'Otra',text: 'Otra'}
            ],
            nacionalidadId:(new Date()).getTime(),
            errorFields:[],
            deshabilitadas: true,
            invalidoCurp: false,
            errorCURP: ''
        }
    },
    computed: {
    },
    methods: {
        numeroMaximo(valor, tipo){
            if(valor.length > 10){ 
                if(tipo == 'celular'){
                    this.info.celular = this.info.celular.slice(0, 10);
                }else if(tipo == 'telefono'){
                    this.info.telefono = this.info.telefono.slice(0, 10);
                }
            }
        },
        deshabilitadasOpciones(){
            if(this.general.personaRol.tipoUserPrincipal != 'Personal central - TI'){
                if((this.general.personaRol.tipoUserPrincipal != 'alumno' || [5, 25, 28].includes(this.general.datos.institucionId))){
                    if((this.general.permisos.includes('perfil-visualizacion'))){
                        this.deshabilitadas = true
                    }else{
                        this.deshabilitadas = false
                    }
                }else{
                this.deshabilitadas = true
            }
            }else{
                this.deshabilitadas = false
            }
        },
        getInfo(){
            const ciudad_id = this.general.datos.ciudad_id == null ? '' : this.general.datos.ciudad_id
            const estado_id = this.general.datos.estado_id == null ? '' : this.general.datos.estado_id
            const nacionalidad = this.general.datos.nacionalidad == null ? '' : this.general.datos.nacionalidad
            const sexo = this.general.datos.sexo == null || this.general.datos.sexo == '' ? '' : this.general.datos.sexo
            let {apellido_paterno = '', apellido_materno = '', nombres = '', fecha_nacimiento = '', curp = '', correo = '', celular = '', telefono = '', extension = '', delegacion = '', cp = '', colonia = '', calle = '', numero = '', lugar_nacimiento = '', no_dependientes = '', vive_con = ''} = this.general.datos
            Object.assign(this.info = {apellido_paterno, apellido_materno, nombres, sexo, fecha_nacimiento, curp, correo, celular, telefono, extension, estado_id, ciudad_id, delegacion, cp, colonia, calle, numero, lugar_nacimiento, nacionalidad, no_dependientes, vive_con})
        },
        async getCiudades(){
            if(this.info.estado_id){
                this.loadingCiudad = true
                try{
                    const {data: response} = await alumnos.getCiudades(this.info.estado_id)
                    this.ciudades = response
                    this.ciudadId = (new Date()).getTime()
                    this.loadingCiudad = false
                }catch{
                    this.loadingCiudad = false
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.info.apellido_paterno){
                this.errorFields.push('apellido_paterno')
            }
            if (!this.info.apellido_materno){
                this.errorFields.push('apellido_materno')
            }
            if (!this.info.nombres){
                this.errorFields.push('nombres')
            }
            if (!this.info.sexo){
                this.errorFields.push('sexo')
            }
            if (!this.info.fecha_nacimiento){
                this.errorFields.push('fecha_nacimiento')
            }
            if (!this.info.correo){
                this.errorFields.push('correo')
            }
            if(this.general.datos.tipo != 'prospecto'){
                if (!this.info.nacionalidad){
                    this.errorFields.push('nacionalidad')
                }
                if (!this.info.curp){
                    this.errorFields.push('curp')
                }
            }
            if (!this.errorFields.length){
                const params = {}
                if(this.general.datos.tipo != 'prospecto'){
                    params.persona_id = this.general.datos.persona_id
                    params.tipo = this.general.datos.tipo
                    params.apellido_paterno = this.info.apellido_paterno
                    params.apellido_materno = this.info.apellido_materno
                    params.nombres = this.info.nombres
                    params.sexo = this.info.sexo
                    params.fecha_nacimiento = this.info.fecha_nacimiento
                    params.curp = this.info.curp
                    params.correo = this.info.correo
                    params.celular = this.info.celular
                    params.telefono = this.info.telefono
                    params.extension = this.info.extension
                    params.estado_id = this.info.estado_id
                    params.ciudad_id = this.info.ciudad_id
                    params.delegacion = this.info.delegacion
                    params.cp = this.info.cp
                    params.colonia = this.info.colonia
                    params.calle = this.info.calle
                    params.numero = this.info.numero
                    params.lugar_nacimiento = this.info.lugar_nacimiento
                    params.nacionalidad = this.info.nacionalidad
                    params.no_dependientes = this.info.no_dependientes
                    params.vive_con = this.info.vive_con
                    params.institucion_id = this.general.datos.institucionId
                }else{
                    params.prospecto_id = this.general.datos. id
                    params.tipo = this.general.datos.tipo
                    params.apellido_paterno = this.info.apellido_paterno
                    params.apellido_materno = this.info.apellido_materno
                    params.nombres = this.info.nombres
                    params.sexo = this.info.sexo
                    params.fecha_nacimiento = this.info.fecha_nacimiento
                    params.correo = this.info.correo
                    params.celular = this.info.celular
                    params.telefono = this.info.telefono
                    params.extension = this.info.extension
                }

                return params
            } else {
                return null
            }
        },
        async postPerfil(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                this.invalidoCurp = false
                let id = ''
                if(this.general.datos.tipo == 'prospecto'){
                    id = this.general.datos.id
                }else{
                    id = this.general.datos.persona_id
                }
                try{
                    const {data: response} = await alumnos.postPerfil(id, this.sanityForm())
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.$emit('refreshComponent', this.general.datos.persona_id, this.general.datos.tipo == 'alumno' ? 'alumno' : 'seguimiento')
                }catch (error){
                    loading.close()
                    console.log(error)
                    
                    const responseError = error.response
                    if (responseError.data.errors.curp && responseError.data.errors.curp[0]) {
                        this.errorFields.push('curp');
                        this.errorCURP = responseError.data.errors.curp[0];
                    } else {
                        // Filtra la lista errorFields para excluir 'curp' sin importar la posición
                        this.errorFields = this.errorFields.filter(item => item !== 'curp');
                    }
                }
            }
        },
        getvalidateCurp(){
            if(this.general.datos.tipo != 'prospecto'){
                const curpExp = new RegExp('[A-Z]{4}[0-9]{6}[HM]{1}[A-Z]{2}[A-Z]{3}[0-9A-Z]{2}')
                this.validateCurp = curpExp.test(this.info.curp.toUpperCase());
                if(this.validateCurp == false){
                    this.invalidoCurp = true
                }
                return this.validateCurp
            }else{
                return true
            }
        },
    },
    watch:{
        'info.estado_id':function(){
            this.getCiudades()
        },
        general(){
            this.deshabilitadasOpciones()
            this.getInfo()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
</style>
